
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/contact-us",
      function () {
        return require("private-next-pages/account/contact-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/contact-us"])
      });
    }
  